// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const actions = {
  fetchTimeAttendanceOffsiteGrants(_, payload) {
    return ApiService.fetchTimeAttendanceOffsiteGrants(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  editTimeAttendanceOffsiteGrant(_, payload) {
    return ApiService.editTimeAttendanceOffsiteGrant(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
}
